export default "/_next/static/images/0a02eea9f31021632931076f09ba74a1.jpg";